import React from "react";
import Landing from "../../../themes";
import GoodToGreat from "./misc/GoodToGreat";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/elements/forms/Button2";
import OurPackages from "./misc/OurPackages";
import ReadyToEnsure from "./misc/ReadyToEnsure";
import WhyChooseUs from "./misc/WhyChooseUs";
import Testimonials from "./misc/Testimonials";

const PostPlacement: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Landing>
      <div className="bg-bgPackages bg-cover bg-center md:h-[550px] h-[400px] w-full font-abel flex items-center">
        <div className="text-center text-[white] max-w-[850px] mx-auto">
          <h1 className="text-3xl md:text-6xl">
            Post-Placement Success Packages
          </h1>
          <p className="text-[16px] md:text-[20px] font-[400] pt-3 px-3">
            Securing top talent is just the beginning. The real measure of
            success is how well that leader integrates, performs, and remains
            committed to your organization over time.
          </p>
          <div className="flex items-center justify-center">
            <Button
              className="bg-[#2D6EEF] text-[#ffffff] md:h-[55px] md:w-[194px] md:text-[17px] mt-5 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101 pulse"
              title="Explore Packages"
              onSubmitHandler={() => navigate(`/`)}
            />
            <div className="w-[10px]"></div>
            <Button
              className="bg-[#ffffff] text-[#000000] md:h-[55px] md:w-[194px] md:text-[17px] mt-5 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101 pulse"
              title="Schedule Consultation"
              onSubmitHandler={() => navigate(`/`)}
            />
          </div>
        </div>
      </div>
      <GoodToGreat />
      <OurPackages />
      <WhyChooseUs />
      <Testimonials />
      <ReadyToEnsure />
    </Landing>
  );
};

export default PostPlacement;
